<div class="container-fluid div-bg p-4">
  <div class="row">
    <div class="col-12 col-lg-8" style="text-align: center;">
      <div class="mb-4">
        <div class="d-flex align-items-center" style="justify-content: center;">
          <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/9498edba-5ab7-4231-9132-36334e2e7c6d?"
            class="img-fluid me-2" />
          <span class="h5 mb-0">partners with <strong>National Post Offices</strong></span>
        </div>
        <div class="mt-3 fs-4 fw-bold launchTitle">to launch a dedicated '<span>Deals App</span>'</div>
        <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/a34dbae2-821c-49c0-a993-3e2217bad47a?"
          class="img-fluid my-3 land-img" />
        <div class="fw-semibold div-18">Create Deals</div>
        <div class="mt-2">
          Efficiently create, modify, manage and track your promotional deals through our sleek and intuitive
          dashboard/Interface.
        </div>

      </div>
      <div class="mt-3 col-lg-12" style="font-size: 12px;text-align: center;">Corporate Website: <a target="_blank"
          href="https://ship2myid.com/">Ship2Myid.com</a>. Ship2MyID is a member of UPU CC (United Nations Organization
        for Global Post offices) | <span class="text-primary" style="font-size: 12px; cursor: pointer;"
          (click)="navigateFaqs()">FAQs</span></div>
    </div>

    <div class="col-12 col-lg-4 mt-5">
      <form>
        <div class="text-center mb-3">
          <span class="fw-bold d-block mb-2">Please select country/post to advertise</span>
        </div>

        <div class="row g-3">
          <div class="col-12 col-md-6 text-center">
            <a (click)="navigateToLogin($event,'B')">
              <img class="img-fluid" src="../../../assets/images/poso_landing_img.png"
                style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgb(0 0 0 / 53%), 0 8px 12px rgb(0 0 0 / 42%);">
            </a>
            <div class="mt-2">BotswanaPost</div>
          </div>

          <div class="col-12 col-md-6 text-center position-relative">
            <!-- <div class="position-relative">
              <img src="../../../assets/images/CILOGO.jpeg" (click)="navigateToLogin($event,'C')"
                style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 12px rgba(0, 0, 0, 0.2);">
              <img src="../../../assets/images/comingsoonb.png" class="position-absolute soon-rt"
                style="top: 20px;width: 50px; height: auto;" />
            </div>
            <div class="mt-2">Cote D'Ivoire</div> -->

            <div class="flag-container">
              <img src="../../../assets/images/CILOGO.jpeg" alt="CI Flag" class="flag-img"
                (click)="navigateToLogin($event,'C')">
              <img src="../../../assets/images/comingsoonb.png" alt="Coming Soon" class="coming-soon-badge">
            </div>
            <p class="country-name">Cote D'Ivoire</p>
          </div>

          <div class="col-12 col-md-6 text-center position-relative">
            <!-- <div class="position-relative">
            <img src="../../../assets/images/zimpost-logo.png" (click)="navigateToLogin($event,'Z')" style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 12px rgba(0, 0, 0, 0.2);">
            <img src="../../../assets/images/comingsoonb.png" class="coming-soon-icon position-absolute soon-rt" style="top: 20px;width: 50px; height: auto;">
            </div>
            <div class="mt-2">Zimbabwe</div> -->
            <div class="flag-container">
              <img src="../../../assets/images/zimpost-logo.png" alt="Zimbabwe Flag" class="flag-img"
                (click)="navigateToLogin($event,'Z')">
              <img src="../../../assets/images/comingsoonb.png" alt="Coming Soon" class="coming-soon-badge">
            </div>
            <p class="country-name">Zimbabwe</p>
          </div>

          <div class="col-12 col-md-6 text-center">
            <img src="../../../assets/images/eqpost.png"
              style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 12px rgba(0, 0, 0, 0.2);">
            <div class="mt-2">Eq Guinea</div>
          </div>

          <div class="col-12 col-md-6 text-center">
            <img src="../../../assets/images/Senegal.png"
              style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 12px rgba(0, 0, 0, 0.2);">
            <div class="mt-2">Senegal</div>
          </div>

          <div class="col-12 col-md-6 text-center">
            <img src="../../../assets/images/Mauritania.png"
              style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 12px rgba(0, 0, 0, 0.2);">
            <div class="mt-2">Mauritania</div>
          </div>

          <div class="col-12 col-md-6 text-center">
            <img src="../../../assets/images/Madagascar.png"
              style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 12px rgba(0, 0, 0, 0.2);">
            <div class="mt-2">Madagascar</div>
          </div>
          <div class="col-12 col-md-6 text-center">
            <img src="../../../assets/images/indiaflag.png"
              style="height: 60px; width: 150px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 12px rgba(0, 0, 0, 0.2);"
              (click)="navigateToLogin($event,'I')">
            <div class="mt-2">India</div>
          </div>
        </div>
      </form>


    </div>

  </div>
  <div class="row">
    <!-- <div class="mt-3 col-lg-12" style="font-size: 12px;text-align: center;">Corporate Website: <a target="_blank"
        href="https://ship2myid.com/">Ship2Myid.com</a>. Ship2MyID is a member of UPU CC (United Nations Organization
      for Global Post offices) | <span class="text-primary" style="font-size: 12px; cursor: pointer;"
        (click)="navigateFaqs()">FAQs</span></div> -->
    <!-- <div class="mt-3 text-center col-lg-4">
     <span class="text-primary me-2" style="font-size: 12px; cursor: pointer;" (click)="navigateTerms()">Terms & Conditions |</span> 
      <span class="text-primary" style="font-size: 12px; cursor: pointer;" (click)="navigateFaqs()">FAQs</span>
    </div> -->
  </div>
</div>